import React, { forwardRef } from "react";
import { SearchIcon } from "@heroicons/react/outline";
import { cn } from "./cn";
import { Input } from "./Field";
import Kbd from "./Kbd";

/**
 * Bun search input: magnifier + placeholder in a control-radius box.
 * Used for "Find a client", "Search households", table filters.
 */
const SearchInput = forwardRef(function SearchInput(
  { className, placeholder = "Search", shortcutHint, variant = "default", ...props },
  ref
) {
  return (
    <div
      className={cn(
        "relative flex items-center font-instrument min-w-0",
        className
      )}
    >
      <SearchIcon className={cn("pointer-events-none absolute left-[11px] w-[14px] h-[14px] text-bun-faint",
        variant === "prominent" && "w-[18px] h-[18px] text-bun-slate")} />
      <Input
        ref={ref}
        type="text"
        placeholder={placeholder}
        className={cn(
          "pl-[33px] placeholder:text-bun-slate",
          shortcutHint ? "pr-14" : "pr-3",
          variant === "prominent" && "sm:min-h-11 bg-bun-mist border-bun-line-strong pl-10 placeholder:text-bun-slate"
        )}
        {...props}
      />
      {shortcutHint && (
        <Kbd className="pointer-events-none absolute right-2">
          {shortcutHint}
        </Kbd>
      )}
    </div>
  );
});

export default SearchInput;
